import React from 'react';
import Modal from '../../../shared/components/modals/Modal';
import './SecurityTrackingHelpModal.css';

export default function SecurityTrackingHelpModal({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Security tracking" size="large">
      <div className="st-help">
        <p className="st-help__lead">
          This section covers <strong>security insights and session activity</strong> at this
          location over the <strong>last 7 days</strong>. For failed-login details and user
          lists, use <strong>User Management → Login health</strong>. For device change history,
          use <strong>Device Audit & Compliance Tracking</strong>.
        </p>

        <section>
          <h3>Security insights</h3>
          <ul className="st-help__list">
            <li>
              <strong>At-risk accounts</strong> — count of known users with suspicious failure
              rates or high failure volume in the window.
            </li>
            <li>
              <strong>Avg session</strong> — estimated average session duration for active users.
            </li>
            <li>
              <strong>Failure rate</strong> — failed attempts as a share of all login
              attempts. Elevated when above 10%.
            </li>
            <li>
              <strong>Risk level</strong> — low, medium, or high based on anomaly count and
              at-risk accounts.
            </li>
          </ul>
        </section>

        <section>
          <h3>Authentication signals</h3>
          <p className="st-help__lead">
            A compact digest of the last 7 days — trend chart, at-risk accounts, and top
            unrecognized usernames. Use <strong>Open login health</strong> for sortable tables
            and full detail.
          </p>
          <ul className="st-help__list">
            <li>
              <strong>Threat categorization</strong> — counts from all login failures in the
              window: wrong password (brute force), user not found (credential stuffing),
              inactive account (lockouts), plus unfamiliar IPs (failures from IPs with no
              successful login in 30 days).
            </li>
            <li>
              <strong>Accounts at risk</strong> — known non-superadmin users with suspicious
              failure rates; org-wide success/failure balance (not location-split).
            </li>
            <li>
              <strong>Unrecognized login attempts</strong> — usernames that do not match any account.
            </li>
            <li>
              <strong>Failed logins timeline</strong> — daily failure volume over the last 7 days
              (including quiet days). Peaks are highlighted; use Login health for user-level detail.
            </li>
          </ul>
        </section>

        <section>
          <h3>Sessions &amp; profile activity</h3>
          <ul className="st-help__list">
            <li>
              <strong>Active sessions</strong> — browser sessions currently logged in at this
              location.
            </li>
            <li>
              <strong>Avg / User</strong> — average concurrent sessions per active user.
            </li>
            <li>
              <strong>Profile updates</strong> — total profile change transactions in the window.
            </li>
            <li>
              <strong>Users modified</strong> — distinct users with profile changes (breadth of
              activity).
            </li>
          </ul>
        </section>
      </div>
    </Modal>
  );
}
